module.exports = __webpack_public_path__ + "static/media/Portrait-10023.8a2c3c0c.jpg";